var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2adb46bbbb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.5 89.105469 L 337 89.105469 L 337 296.105469 L 37.5 296.105469 Z M 37.5 89.105469 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2adb46bbbb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 234.089844 199.464844 L 195.253906 235.667969 C 190.839844 239.789062 183.988281 239.789062 179.574219 235.667969 L 143.414062 201.960938 L 58.390625 293.363281 C 62.59375 295.207031 67.234375 296.238281 72.125 296.238281 C 72.125 296.238281 302.707031 296.238281 302.707031 296.238281 C 307.683594 296.238281 312.414062 295.171875 316.675781 293.253906 Z M 41.984375 107.390625 L 126.597656 186.28125 L 41.679688 277.570312 C 39.304688 272.925781 37.972656 267.664062 37.972656 262.085938 C 37.972656 262.085938 37.972656 123.464844 37.972656 123.464844 C 37.972656 117.652344 39.421875 112.183594 41.984375 107.390625 Z M 332.847656 107.390625 C 335.40625 112.183594 336.859375 117.652344 336.859375 123.464844 L 336.859375 262.085938 C 336.859375 267.558594 335.570312 272.734375 333.277344 277.320312 L 250.910156 183.777344 Z M 315.753906 91.898438 L 187.414062 211.546875 L 59.078125 91.898438 C 63.09375 90.230469 67.5 89.316406 72.125 89.316406 C 72.125 89.316406 302.707031 89.316406 302.707031 89.316406 C 307.328125 89.316406 311.734375 90.230469 315.753906 91.898438 Z M 315.753906 91.898438 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.93010facccaeadb6d2029e3cc6a170bb.svg";
export { ForwardRef as ReactComponent };